<template>
  <div class="maintenance-filters bg-white p-4 rounded-lg shadow-sm">
    <h3 class="text-lg font-semibold mb-4">Filters</h3>
    
    <div class="space-y-4">
      <!-- Maintenance Type Filter -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Maintenance Type</label>
        <select v-model="filters.maintenance_type" class="w-full p-2 border border-gray-300 rounded-md">
          <option value="">All Types</option>
          <option value="scheduled">Scheduled</option>
          <option value="repair">Repair</option>
          <option value="inspection">Inspection</option>
        </select>
      </div>

      <!-- Equipment Filter -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Equipment</label>
        <select v-model="filters.equipment_id" class="w-full p-2 border border-gray-300 rounded-md">
          <option value="">All Equipment</option>
          <option v-for="eq in equipmentList" :key="eq.id" :value="eq.id">
            {{ eq.name }}
          </option>
        </select>
      </div>

      <!-- Date Range -->
      <div class="grid grid-cols-2 gap-2">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">From Date</label>
          <input type="date" v-model="filters.start_date" class="w-full p-2 border border-gray-300 rounded-md">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">To Date</label>
          <input type="date" v-model="filters.end_date" class="w-full p-2 border border-gray-300 rounded-md">
        </div>
      </div>

      <!-- Cost Range -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Cost Range</label>
        <select v-model="filters.cost_range" class="w-full p-2 border border-gray-300 rounded-md">
          <option value="">Any Cost</option>
          <option value="0-100">TSH 0 - TSH 100</option>
          <option value="100-500">TSH 100 - TSH 500</option>
          <option value="500-1000">TSH 500 - TSH 1,000</option>
          <option value="1000+">TSH 1,000+</option>
        </select>
      </div>

      <!-- Action Buttons -->
      <div class="flex space-x-2 pt-2">
        <button @click="applyFilters" class="btn-primary flex-1">Apply Filters</button>
        <button @click="resetFilters" class="btn-secondary flex-1">Reset</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useEquipmentStore } from '@/stores/equipmentStore';

interface Filters {
  maintenance_type: string;
  equipment_id: string;
  start_date: string;
  end_date: string;
  cost_range: string;
}

const emit = defineEmits<{
  (e: 'filter', filters: Partial<Filters>): void;
}>();

const equipmentStore = useEquipmentStore();
const filters = ref<Filters>({
  maintenance_type: '',
  equipment_id: '',
  start_date: '',
  end_date: '',
  cost_range: ''
});

const equipmentList = computed(() => equipmentStore.equipment);

const applyFilters = () => {
  const appliedFilters: Partial<Filters> = {};
  
  if (filters.value.maintenance_type) appliedFilters.maintenance_type = filters.value.maintenance_type;
  if (filters.value.equipment_id) appliedFilters.equipment_id = filters.value.equipment_id;
  if (filters.value.start_date) appliedFilters.start_date = filters.value.start_date;
  if (filters.value.end_date) appliedFilters.end_date = filters.value.end_date;
  if (filters.value.cost_range) appliedFilters.cost_range = filters.value.cost_range;

  emit('filter', appliedFilters);
};

const resetFilters = () => {
  filters.value = {
    maintenance_type: '',
    equipment_id: '',
    start_date: '',
    end_date: '',
    cost_range: ''
  };
  emit('filter', {});
};
</script>